import React, { useContext } from "react";
import { Modal } from "antd";
import { AuthContext } from "../context/AuthProviderWrapper";

function LoginPopupModal() {
  const { loginPopupVisible, setLoginPopupVisible, loginPopupConfig } =
    useContext(AuthContext);

  return (
    <Modal
      title={loginPopupConfig.title}
      open={loginPopupVisible}
      onOk={() => setLoginPopupVisible(false)}
      onCancel={() => setLoginPopupVisible(false)}
      cancelButtonProps={{ style: { display: 'none' } }}
      okText="OK"
    >
      <p>{loginPopupConfig.message}</p>
    </Modal>
  );
}

export default LoginPopupModal;
